<template>
    <div class="form" ref="formPage" :style="customStyle">
        <nav-bar :title="title" v-if="viewType !== NOTICE_TYPE.FORM">
            <div
                v-if="backButtonVisible"
                slot="left-button"
                class="nav-back-button"
                @click="backToService"
            >
            </div>
        </nav-bar>
        <steps
            :steps="steps"
            :reject-pages="rejectPages"
            :gray="fieldReview"
            :has-changed-reject-review="hasChangedRejectReviewCurPage"
            @step-click="onStepClick"
            v-show="steps.length > 1"
        ></steps>
        <!-- FIXME:这里各种状态以及灰度非灰度的固定不固定，yoda非yoda的给我搞麻了。。后续有类似需求，再改下这里吧 -->
        <mobile-general-form
            ref="mobileGeneralForm"
            :class="[
                fieldReview && status !== 1 && steps.length > 1 ? 'mt9' : '',
                (status === 1 || inYoda) && steps.length > 1 && !useTitle ? 'in-yoda-nav' : '',
                status !== 3 && steps.length <= 1 ? 'no-top' : '',
                (status === 3 && steps.length <= 1) || formNotice ? 'one-page-fixed' : '',
                inYoda && steps.length < 1 ? 'no-top' : ''
            ]"
            :config="formConfig"
            :form-attributes="formAttributes"
            :form-data="formData"
            :error-data="curErrorData"
            :global-form-data="userData || null"
            :init-params="formInitParams"
            :handle-api-action="axiosRequest"
            :logger-method="generalFormLogger"
            :remark="announcementRemark"
            :form-notice="formNotice"
            :field-review="hitGrayAndStatus ? fieldReview : 0"
            :noticeAutoOpen="hitGrayAndStatus ? noticeAutoOpen : true"
            :preview="noticeFormPreview"
            :noticeFormPreview="noticeFormPreview"
            :hideSubmitStyle="hideSubmitStyle"
            @back-to-first="backToPage(0)"
            @exit-webview="callExitWebView"
            @submit-valid="onSubmitValid"
            @form-data-change="onFormDataChange"
        ></mobile-general-form>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Steps from '@/components/Steps.vue';
import MobileGeneralForm from '@/components/mobile-general-form/form';
import NavBar from '@/components/NavBar.vue';
import { axiosRequest, postLoginRenewal, saveDraft } from '@/utils/fetch';
import { PAGE_STATUS_MAP } from '@/utils/constant';
import { exitWebView, setPageTitle } from '@/utils/bridge';
import { toast } from '@/utils/toast';
import { jumpViewProgress } from '@/utils/util';
import { Dialog } from '@ks/sharp-ui';
import localCache from '@/utils/cache';
import { inYoda } from '@/utils/device';
import { sendClickImmediately, sendPV, sendShowImmediately, customLog, customType, resultType } from '@/common/weblog';
import formEventBus, { FORM_EVENTS_TYPE } from '@ks/mobile-general-form/src/form/utils/event-bus';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import { NOTICE_TYPE } from '@ks/mobile-general-form/src/form/const';

export default {
    name: 'bform',
    components: {
        Steps,
        MobileGeneralForm,
        NavBar,
    },
    props: {
        pageKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            startSetCache: false,
            loginRenewalThrottle: throttle(this.initPostLoginRenewal, 60000, {
                leading: true,
                trailing: false,
            }),
            // 【草稿互通】saveDraftThrottle 在 created() 中初始化，以便访问 this.$store / this.$route
            saveDraftThrottle: null,
            hasChangedRejectReviewCurPage: [], // 用来控制步骤条的！是否展示
            curPageKeyData: '', // 当前表单修改的数据
            grayNextPage: '', // 灰度中的下一个页面
            clickStep: false, // 点击顶部步骤条
            inYoda: inYoda,
            NOTICE_TYPE,
        };
    },
    watch: {
        title: {
            immediate: true,
            handler: 'setPageTitle',
        },
    },
    computed: {
        ...mapState([
            'currentBizInfo',
            'extraInfo',
            'currentBizKey',
            'routerPageKey',
            'userData',
            'from',
            'originBizKey',
            'soid',
            'entranceId',
            'source',
            'stashEffectiveDuration',
            'ticket',
            'announcementRemark',
            'formNotice',
            'status',
            'gray',
            'errorData',
            'bizInfo',
            'noticeAutoOpen',
            'viewType',
            'useTitle',
        ]),
        ...mapGetters([
            'steps',
            'isSubmitting',
            'bizConfig',
            'currentPageIndex',
            'pageNames',
        ]),
        ...mapGetters({
            formConfig: 'currentPageFormConfig',
            formAttributes: 'currentPageExtraConfig',
            formData: 'currentDetail',
            title: 'currentPageTitle',
            curErrorData: 'currentPageErrorData',
            rejectPages: 'currentRejectPages',
        }),
        fieldReview() {
            return this.gray && this.gray.fieldReview;
        },
        formInitParams() {
            return {
                ...this.bizConfig,
                ...this.$route.params,
                from: this.$route.query.from,
                ...this.$store.state.collectExtension || {},
            };
        },
        cacheKey() {
            return `cacheKey_${this.currentBizKey}_${this.from || 'default'}`;
        },
        backButtonVisible() {
            return document.referrer && this.originBizKey;
        },
        customStyle() {
            if (this.useTitle) {
                return {
                    paddingTop: '88px',
                };
            }
            const paddingTop = inYoda || this.viewType === NOTICE_TYPE.FORM ? '0' : '44px';
            return {
                paddingTop,
            };
        },
        hitGrayAndStatus() {
            const { config = {} } = this.bizInfo;
            const { needProcess } = config;
            return this.status === 3 && needProcess;
        },
        noticeFormPreview() {
            return this.viewType === NOTICE_TYPE.FORM;
        },
        hideSubmitStyle() {
            return this.viewType === NOTICE_TYPE.FORM;
        },
    },
    methods: {
        axiosRequest,
        setPageTitle,
        ...mapActions([
            'backToPage',
            'triggerMutate',
            'saveCurrentPageData',
            'saveExtraInfo',
            'submit',
            'saveNextPageKey',
            'updateLandingStatus',
        ]),
        ...mapMutations([
            'updateErrorData',
        ]),
        callExitWebView() {
            exitWebView();
        },
        showDialog(currentPageKey) {
            return this.rejectPages.includes(currentPageKey) && !this.hasChangedRejectReviewCurPage.includes(currentPageKey);
        },
        goNextPageByStep(nextPageKey) {
            this.grayNextPage = nextPageKey;
            if (this.currentPageIndex === this.pageNames.length - 1) {
                this.clickStep = true;
            }
            // 最后一页不支持提交。。
            this.$refs.mobileGeneralForm.onSubmitClick({
                source: 'clickByStep',
            });
        },
        onStepClick(clickParams) {
            const { idx, nextPageKey, isError, curIndex } = clickParams;
            this.sendLog('CLICK', 'NAVIGATION_BAR', {
                nav_title: this.pageNames[idx],
                is_error: isError ? 1 : 0,
            });
            // 当在四期灰度中、信息收集配置【需要审核】、表单状态为被驳回 3 表单状态为待修改 1
            if (this.fieldReview && (this.hitGrayAndStatus || this.status === 1)) {
                if (idx === curIndex) {return;}
                this.goNextPageByStep(nextPageKey);
            } else {
                this.backToPage(idx);
            }
        },
        onSubmitValid(formData, { mappedData }, source) {
            if ('production' !== process.env.NODE_ENV) {
                console.log(formData, mappedData);
            }
            if (this.fieldReview && this.hitGrayAndStatus) {
                if (this.showDialog(this.routerPageKey)) {
                    customLog({
                        type: customType.Custom,
                        category: 'DIALOG_SHOW',
                        extra: {
                            routerPageKey: this.routerPageKey,
                            url: window.location.href,
                        },
                    });
                    Dialog.confirm({
                        content: '审核没通过的内容仍未修改，请确认是否提交',
                        confirmText: '是',
                        cancelText: '否',
                        onConfirm: () => {
                            customLog({
                                type: customType.Custom,
                                category: 'DIALOG_CONFIRM',
                            });
                            const curFormData = this.userData[this.routerPageKey];
                            const isMoreEqual = this.compareKeys(curFormData, formData);
                            if (isMoreEqual) {
                                this.submitPageData({ formData, mappedData, source });
                            } else {
                                customLog({
                                    type: customType.Custom,
                                    category: 'EQUAL_FORM_DATA',
                                });
                            }
                        },
                    });
                } else {
                    this.submitPageData({ formData, mappedData, source });
                    customLog({
                        type: customType.Custom,
                        category: 'DIALOG_HIDE',
                    });
                }
            } else {
                this.submitPageData({ formData, mappedData, source });
                customLog({
                    type: customType.Custom,
                    category: 'NO_DIALOG',
                });
            }
        },
        // 最后一步的提交处理逻辑
        async lastPageSubmit() {
            if (this.bizConfig.mergeSubmit) {
                // 需要合并提交则最后一步的时候submit
                try {
                    await this.submit();
                } catch (e) {
                    toast.error(e.message);
                    this.triggerMutate({ isSubmitting: false });
                    return;
                }
            }
            // 提交结束后删除cache对应数据
            localCache.removeSync(this.cacheKey);
            // 【草稿互通】取消尚未触发的防抖保存，防止在删除后又重新写入草稿
            this.saveDraftThrottle.cancel();
            // 【草稿互通】提交成功后删除服务端草稿（data 传 null 触发后端删除语义，失败静默忽略）
            // 此处同步快照 bizKey 和 from，确保异步回调时值正确
            saveDraft({ bizKey: this.currentBizKey, from: this.from, data: null }).catch(() => {
                // console.warn('[deleteDraft] 失败，忽略');
            });
            // 若设置了exitHref，则直接跳转到该页面
            if (this.bizConfig.exitHref) {
                window.location.href = this.bizConfig.exitHref;
                return;
            }
            // 通过判断是否需要登录来辨别是端内页面还是端外页面
            // 且没有from参数
            if (!this.bizConfig.mustLoggedOn && !this.from) {
                // 端外页面目前只能停留在本页并尝试关闭
                Dialog.alert({
                    title: '提交成功',
                    content: '提交成功，可关闭当前页面',
                    confirmText: '好的',
                    onConfirm: () => this.callExitWebView(),
                });
                this.triggerMutate({ isSubmitting: false });
            } else {
                const { code, soid } = this.ticket;
                if (code === 2 && soid) {
                    Dialog.confirm({
                        content: '查询到您已提交过相同问题，请前往查看处理进展',
                        confirmText: '查看进度',
                        cancelText: '取消',
                        onConfirm: () => {
                            jumpViewProgress(soid);
                        },
                    });
                }
                // 端内页面需跳转到landing页
                let updateStatusDone = false;
                // landing页的状态必须要拿到，没办法只能轮询了
                while (!updateStatusDone) {
                    try {
                        await this.updateLandingStatus({ bizKey: this.currentBizKey });
                        updateStatusDone = true;
                    } catch (e) {
                        // do nothing
                    }
                }
                const params = `&originBizKey=${this.originBizKey}&soid=${this.soid}&source=${this.source}&entranceId=${this.entranceId}`;
                this.$router.replace(`/biz/${this.currentBizKey}/landing?from=${this.from}${params}`,
                    () => this.triggerMutate({ isSubmitting: false }));
            }
        },
        compareKeys(obj1, obj2) {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            const uniqueToObj1 = keys1.filter(key => !(key in obj2));
            const uniqueToObj2 = keys2.filter(key => !(key in obj1));
            // 合并两个数组，得到所有不同的键
            const differentKeys = [...uniqueToObj1, ...uniqueToObj2];
            // 检查不同键的数量是否小于3
            return differentKeys.length < 4;
        },
        async submitPageData({ formData, mappedData, source }) {
            const clickByStep = source ? source.source === 'clickByStep' : false;
            // 不是通过步骤条点击，支持提交
            if (!clickByStep) {this.clickStep = false;}
            customLog({
                type: customType.Custom,
                category: 'SUBMIT_STATUS',
                extra: {
                    submit_status: this.isSubmitting,
                    routerPageKey: this.routerPageKey,
                },
            });
            if (this.isSubmitting) {
                toast.error('请勿重复点击提交');
                customLog({
                    type: customType.Custom,
                    category: 'IS_SUBMIT_TING',
                    extra: {
                        formData,
                        routerPageKey: this.routerPageKey,
                        url: window.location.href,
                    },
                });
                return;
            }
            this.triggerMutate({ isSubmitting: true });

            sendClickImmediately('SUBMIT');
            const { name, params = {}, query = {} } = this.$route;
            if (name && name !== 'biz') {
                sendPV('CSC_COLLECT_PAGE', 'leave', {
                    biz_key: params.bizKey || '',
                    page_key: params.pageKey,
                    from_key: query.from || -1,
                });
            }
            customLog({
                type: customType.Click,
                category: 'SUBMIT_PAGE_DATA',
                extra: {
                    formData,
                    routerPageKey: this.routerPageKey,
                    biz_key: params.bizKey || '',
                    page_key: params.pageKey,
                    from_key: query.from || -1,
                    url: window.location.href,
                },
            });

            // 保存当前填写过的数据
            this.saveCurrentPageData({
                pageKey: this.routerPageKey,
                data: formData,
            });
            console.log('submitPageData', formData);
            // 保存其他额外的参数字段
            this.saveExtraInfo(mappedData);
            if (!this.bizConfig.mergeSubmit) {
                // 不合并提交，则每次跳转页面都需要提交数据
                try {
                    await this.submit(formData);
                } catch (e) {
                    toast.error(e.message);
                    this.triggerMutate({ isSubmitting: false });
                    return;
                }
            }

            // TODO: 避免出现提交loading的情况无数据排查
            const extraParams = {
                click_step: this.clickStep,
                current_page: this.currentPageIndex,
                page_name_length: this.pageNames.length - 1,
            };
            customLog({
                type: customType.Click,
                category: 'CLICK_SUBMIT',
                extra: {
                    biz_key: params.bizKey || '',
                    page_key: params.pageKey,
                    from_key: query.from || -1,
                    url: window.location.href,
                    ...extraParams,
                },
            });

            // 通过步骤条点击，不提交。当前若已经到达了最后一个页面，提交成功后，下个页面直接跳转到landing页或者退出
            if (!this.clickStep && this.currentPageIndex === this.pageNames.length - 1) {
                customLog({
                    type: customType.Click,
                    category: 'LAST_PAGE_SUBMIT',
                    extra: {
                        submit_status: this.isSubmitting,
                    },
                });
                await this.lastPageSubmit();
                return;
            }
            const defaultNextPage = this.pageNames[this.currentPageIndex + 1];
            // 正常跳转下一页
            /**
             * 下面两个条件，取默认defaultNextPage
             * 1. 没有开启需要审核、状态不是3 没有在灰度
             * 2. 在灰度 通过按钮点击
             * 取默认defaultNextPage
             */
            const nextPage = !this.hitGrayAndStatus && !this.fieldReview || !clickByStep
                ? defaultNextPage
                : this.grayNextPage || defaultNextPage;
            // 更新可以到达的下一页
            this.saveNextPageKey({ pageKey: nextPage });
            // iOS跳转时不会滚动到页面顶部，这里手动调用一次
            this.$refs.formPage.scrollIntoView();
            // 跳转下一页
            this.$router.push({
                params: {
                    pageKey: nextPage,
                },
                query: {
                    from: this.from,
                    originBizKey: this.originBizKey,
                    soid: this.soid,
                    source: this.source,
                    entranceId: this.entranceId,
                },
            }, () => {
                setTimeout(() => {
                    this.triggerMutate({ isSubmitting: false });
                }, 300);
            });
        },
        /**
         * 传入移动端通用表单用于响应埋点动作
         * 埋点分成两个部分，业务埋点、研发埋点
         * 业务埋点指中台服务方需要的数据，pv、click等（webblog 待完善）
         * 研发埋点指用户使用时上报的可以帮助研发定位问题的信息（暂时使用 ksLog）
         */
        generalFormLogger({ action = '', params = null }) {
            if (process.env.NODE_ENV !== 'production') {
                return;
            }
            if (action.startsWith('upload')) {
                const { ksLog = {} } = window; // ksLog就是如此霸气地挂在window上的存在
                if (typeof ksLog.sendCountTag === 'function') {
                    ksLog.sendCountTag(`h5Collect_${action}_${JSON.stringify(params)}`);
                }
            }
        },
        async onFormDataChange(formData, hasChangeAllField) {
            // 只有 INVALID(0) 状态（第一次填写、尚未提交）才允许保存草稿
            if (this.startSetCache && this.routerPageKey && this.status === PAGE_STATUS_MAP.INVALID) {
                const userData = this.userData || {};
                const data = {
                    ...userData,
                    [this.routerPageKey]: formData,
                };
                localCache.set(this.cacheKey, data);
                this.loginRenewalThrottle();
                // 【草稿互通】同步保存到服务端草稿（防抖 2s，失败静默降级）
                // 在调用时快照 bizKey 和 from，防止 2s 后防抖触发时两者已变更
                this.saveDraftThrottle({ bizKey: this.currentBizKey, from: this.from, data });
            }

            // 这里是信息收集四期的逻辑
            if (this.hitGrayAndStatus) {
                this.curPageKeyData = formData;
                this.dealErrorData(hasChangeAllField);
            }
        },
        dealErrorData(hasChangeAllField) {
            // hasChangeAllField === [] 代表所有驳回字段都已经修改完成
            if (Array.isArray(hasChangeAllField) && hasChangeAllField.length === 0) {
                this.hasChangedRejectReviewCurPage.push(this.routerPageKey);
                const res = this.errorData.map(v => {
                    if (v.pageKey === this.routerPageKey) {
                        v.markList.forEach(i => {
                            i.outputList.map(item => {
                                item.isChanged = true;
                            });
                        });
                    }
                    return v;
                });
                this.updateErrorData(res);
            }
        },
        async initPostLoginRenewal() {
            try {
                await postLoginRenewal({ bizKey: this.currentBizKey });
            } catch (error) {
                console.error(error, '/verify/login-renewal 接口异常');
            }
        },
        backToService() {
            const { originBizKey, soid, source, entranceId } = this;
            const origin = document.referrer || location.origin.replace('collect', 'center');
            // 测试域名有中缀路径
            const infix = origin.includes('staging') ? 'ks-fe-csc-mobile/gefei/' : '';
            // eslint-disable-next-line
            location.href = `${origin}/${infix}/service/?enableWK=1&layoutType=4#/service-detail?bizKey=${originBizKey}&soid=${soid}&source=${source}&entranceId=${entranceId}`;
        },
        sendLog(type, action, extraParams) {
            const { params = {}, query = {} } = this.$route;
            const finalParams = {
                msg_id: -1,
                irid: -1,
                biz_key: params.bizKey || '',
                page_key: params.pageKey,
                from_key: query.from || -1,
                card_type: this.bizConfig.halfScreen ? 1 : 2,
                collect_status: 1,
                ...extraParams,
            };
            switch (type) {
                case 'SHOW':
                    sendShowImmediately(action, finalParams);
                    break;
                case 'CLICK':
                    sendClickImmediately(action, finalParams);
                    break;
                case 'API':
                    customLog({
                        type: customType.Api,
                        category: action,
                        result: extraParams.result || resultType.Unset,
                        message: extraParams.message || '',
                        extra: finalParams,
                    });
                    break;
                case 'CUSTOM':
                    customLog({
                        type: customType.Upload,
                        category: action,
                        extra: {
                            biz_key: params.bizKey || '',
                            page_key: params.pageKey,
                            from_key: query.from || -1,
                            url: window.location.href,
                            ...extraParams,
                        },
                    });
                    break;
                default:
                    customLog({
                        category: action,
                        extra: {
                            ...finalParams,
                            ...extraParams,
                        },
                    });
                    break;
            }
        },
    },
    created() {
        // 【草稿互通】服务端草稿防抖保存，2s 防抖，用箭头函数绑定 this，以便处理 checkPhone 验真跳转
        // 接受 { bizKey, from, data } 快照参数，防止防抖延迟触发时读到已变更的 this.currentBizKey / this.from
        this.saveDraftThrottle = debounce(async ({ bizKey, from, data }) => {
            let res;
            try {
                res = await saveDraft({ bizKey, from, data });
            } catch (e) {
                // 静默失败，不影响本地缓存和主流程
                // console.warn('[saveDraft] 失败，静默降级', e);
                return;
            }
            // 【草稿互通】后端保存草稿时也可能返回 checkPhone，需要触发验真页跳转
            if (res && res.checkPhone) {
                this.$store.commit('changeCheckPhone', res.checkPhone);
                this.$store.dispatch('setCurrentRouter', {
                    bizKey: this.currentBizKey,
                    name: this.$route.name,
                });
            }
        }, 2000);
    },
    mounted() {
        setTimeout(() => {
            localCache.setOptions({
                expiredMs: this.stashEffectiveDuration,
            });
            localCache.clearExpired();
            this.startSetCache = true;
        }, 2000);
        formEventBus.$on(FORM_EVENTS_TYPE.SEND_FORM_LOG, this.sendLog);
    },
    beforeDestroy() {
        // 【草稿互通】组件销毁时取消尚未触发的防抖保存，防止销毁后写入脏数据
        this.saveDraftThrottle.cancel();
        formEventBus.$off(FORM_EVENTS_TYPE.SEND_FORM_LOG, this.sendLog);
    },
};
</script>
<style lang="less" scoped>
.mt9 {
    margin-top: 0.85rem;
    /deep/ .mobile-general-form-container {
        margin-top: 0.40rem;
    }
}
.no-top-mt {
    /deep/ .mobile-general-form-container {
        margin-top: 0.40rem;
    }
}
.one-page-fixed {
    /deep/ .mobile-general-form-container {
        margin-top: 0.40rem;
    }
    /deep/ .fixed-notice-bar {
        position: fixed!important;;
        width: 100%!important;;
        z-index: 888!important;;
        top: auto!important;
        left: 0!important;;
    }
}
.in-yoda-nav {
    margin-top:  0.85rem;
    /deep/ .fixed-notice-bar {
        position: fixed!important;;
        width: 100%!important;;
        z-index: 888!important;;
        top: 84px!important;
        left: 0!important;;
    }
}
.no-top {
    /deep/ .fixed-notice-bar {
        position: fixed!important;;
        width: 100%!important;;
        z-index: 888!important;;
        top: auto!important;
        left: 0!important;;
    }
}
.form {
    flex: 1;
    display: flex;
    flex-direction: column;
    .mobile-general-form {
        margin-bottom: 0.08rem;
        flex: 1 1;
        display: flex;
        flex-direction: column;
        /deep/ a {
            color: #385080;
        }
        /deep/ .mobile-general-form-container {
            flex: 1 1;
            display: flex;
            flex-direction: column;
            .other {
                flex: 1;
            }
        }
    }
}
.nav-back-button {
    position: absolute;
    top: 50%;
    left: 10px;
    width: 30px;
    height: 30px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    background-position: 50%;
    background-repeat: no-repeat;
    z-index: 1001;
    background-image: var(--csc-collect-icon-back);
    background-size: 100% auto;
}
</style>
